export * from './type';
// disabled without shipped https://github.com/tc39/proposal-class-method-parameter-decorators
// export * from './decorator';
export * from './decorator-stage3';
